function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M127.179 128.001C140.099 116.192 148.195 99.2495 148.195 80.4274C148.195 44.7429 119.094 15.8149 83.1952 15.8149C47.2966 15.8149 18.1952 44.7429 18.1952 80.4274C18.1952 100.236 27.1625 117.963 41.282 129.815",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M115.676 113.478C125.216 104.777 131.195 92.293 131.195 78.4242C131.195 52.1303 109.705 30.8149 83.1952 30.8149C56.6855 30.8149 35.1952 52.1303 35.1952 78.4242C35.1952 93.02 41.8172 106.082 52.2439 114.815",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M99.7885 292.039C99.7885 292.039 77.3017 267.658 73.3451 265.483C69.3886 263.308 61.2512 255.557 57.7453 250.059C54.2394 244.561 30.0506 191.939 27.8954 188.804C25.7402 185.669 25.7402 179.656 29.2802 178.004C32.8202 176.351 41.6757 174.759 46.779 179.656C51.8823 184.553 69.6118 211.082 69.6118 211.082V94.8287C69.6118 87.7436 75.3554 82 82.4405 82V82C89.5256 82 95.2692 87.7436 95.2692 94.8287V159.073L95.7656 148.756C96.1035 141.734 101.895 136.214 108.926 136.214V136.214C116.061 136.214 121.899 141.894 122.096 149.026L122.579 166.548V161.659C122.579 154.788 128.149 149.219 135.019 149.219V149.219C141.814 149.219 147.351 154.671 147.457 161.465L147.73 178.987L148.399 171.85C148.916 166.343 153.983 162.423 159.443 163.307V163.307C164.071 164.056 167.473 168.053 167.473 172.742V181.804C167.473 181.804 168.698 225.444 167.473 230.374C166.249 235.304 158 260.712 158 264.062C158 267.412 158.001 276.65 168.684 292.039",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M138.006 141.555C154.106 126.846 164.195 105.742 164.195 82.2972C164.195 37.8481 127.93 1.81494 83.1952 1.81494C38.4601 1.81494 2.19516 37.8481 2.19516 82.2972C2.19516 106.971 13.3698 129.052 30.9649 143.815",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgTapIcon = function SvgTapIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 294,
    viewBox: "0 0 171 294",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTapIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Tap_icon.d2d94ed8.svg";
export { ForwardRef as ReactComponent };